'use client';

import { useState, useTransition } from 'react';
import './LoginForm.css';
import { Link, useNavigate } from 'react-router-dom';
import { useLoginMutation } from '../api/authApi';
import { setUser } from '../slices/authSlice';
import { useDispatch } from 'react-redux';

export default function LoginForm({ setView }) {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [isPending, startTransition] = useTransition();
  const [loginApi] = useLoginMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    startTransition(async () => {
      try {
        const loginResponse = await loginApi(formData).unwrap();
        if (loginResponse.success) {
          dispatch(setUser(loginResponse.data));
          return navigate('/');
        }
      } catch (err) {
        setError(err?.data?.message || err?.message || err?.error || 'Invalid email or password');
      }
    });
  };

  return (
    <div className="container">
      <div className="card">
        <h1 className="title">Welcome Back</h1>
        {error && <p className="error">{error}</p>}

        <form onSubmit={handleSubmit} className="form">
          <div className="formGroup">
            <label htmlFor="email" className="label">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="input"
              placeholder="abc@example.com"
            />
          </div>

          <div className="formGroup">
            <label htmlFor="password" className="label">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="input"
              placeholder="••••••••"
              minLength="5"
            />
            <button
              type="button"
              onClick={() => setView('forgot')}
              className="link"
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: '0.8rem', textAlign: 'right', padding: 0, marginTop: '2px'
              }}
            >
              Forgot Password?
            </button>
          </div>

          <button type="submit" className="button" disabled={isPending}>
            {isPending ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="footer">
          <button
            type="button"
            onClick={() => setView('register')}
            className="link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.875rem' }}
          >
            Create account
          </button>
        </div>
      </div>
    </div>
  );
}
